import { getVariant } from './variant.js';

/**
 * Used for styles with variants
 * @param choices styles variants
 */
var themeVariant = function themeVariant(choices) {
  return function (styleProps) {
    var variant = getVariant(styleProps);
    var selection = choices[variant];
    return typeof selection === 'function' ? selection(styleProps) : selection;
  };
};

export { themeVariant };
